import { Overlays } from '../overlays/overlay';
import { AbstractRendererImpl } from '../abstract_renderer';
import { Q } from '@fullstory/tomato';

export class MobileOverlays extends Overlays {
  constructor(_renderer: AbstractRendererImpl) {
    super(_renderer);
  }

  protected createTouchElement(): Q.OfOne {
    // mobile touch overlays are centered differently, so we add the 'mobile' css class in order to account for that
    return super.createTouchElement().addClass('mobile');
  }
}
